import { Component, EmbeddedViewRef } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';

import {
  IgxExcelExporterOptions,
  IgxExcelExporterService,
  IgxGridComponent,
  IgxGridModule,
  IgxTabContentComponent,
  IgxTabsModule,
} from '@infragistics/igniteui-angular';
import { IgxGridRowComponent } from '@infragistics/igniteui-angular/lib/grids/grid/grid-row.component';
import { IgxGridCellComponent } from '@infragistics/igniteui-angular/lib/grids/cell.component';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-new-rate-home',
  standalone: true,
  imports: [
    MatTabsModule,
    IgxGridModule,
    IgxGridComponent,
    MatIconModule,
    DatePipe,
    IgxTabContentComponent,
    IgxTabsModule,
  ],
  templateUrl: './new-rate-home.component.html',
  styleUrl: './new-rate-home.component.scss',
})
export class NewRateHomeComponent {
  marketRate: ISampleMarketRate[] = [];

  constructor() {
    this.initSampleMarketRates();
  }

  initSampleMarketRates(): void {
    let newMarketRate: ISampleMarketRate = {} as ISampleMarketRate;

    newMarketRate.rateNumber = 1;
    newMarketRate.stallType = 'Reserved';
    (newMarketRate.description = 'Reserved Market Rate'), (newMarketRate.startDate = new Date());
    newMarketRate.endDate = new Date();
    newMarketRate.netRate = 100.0;
    newMarketRate.grossRate = 110.0;
    newMarketRate.quantity = 10;
    newMarketRate.isPortal = false;

    this.marketRate.push(newMarketRate);

    newMarketRate = {} as ISampleMarketRate;

    newMarketRate.rateNumber = 2;
    newMarketRate.stallType = 'Unreserved';
    (newMarketRate.description = 'Unreserved Market Rate'), (newMarketRate.startDate = new Date());
    newMarketRate.endDate = new Date();
    newMarketRate.netRate = 200.0;
    newMarketRate.grossRate = 210.0;
    newMarketRate.quantity = 20;
    newMarketRate.isPortal = false;

    this.marketRate.push(newMarketRate);
  }
}

export interface ISampleMarketRate {
  rateNumber: number;
  stallType: string;
  description: string;
  startDate: Date;
  endDate: Date;
  netRate: number;
  grossRate: number;
  quantity: number;
  isPortal: boolean;
}
